import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { getSeriesColors } from '../../dashboardChartColors';

const CHART_HEIGHT = 280;

function DashboardDonutChart({ series = [], title }) {
    const labels = series.map((item) => item.label);
    const values = series.map((item) => item.value);
    const colors = getSeriesColors(series);

    const options = {
        chart: {
            type: 'donut',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        labels,
        colors,
        dataLabels: {
            enabled: true,
            formatter: (val) => `${Math.round(val)}%`,
            style: { fontSize: '11px', fontWeight: 600 },
            dropShadow: { enabled: false },
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '12px',
            markers: { width: 10, height: 10, radius: 4 },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '58%',
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: title || 'Total',
                            fontSize: '12px',
                            color: '#78829d',
                            formatter: (w) =>
                                w.globals.seriesTotals.reduce((sum, val) => sum + val, 0).toLocaleString(),
                        },
                    },
                },
            },
        },
        stroke: { width: 3, colors: ['#fff'] },
        tooltip: {
            y: { formatter: (val) => val.toLocaleString() },
        },
    };

    return (
        <ReactApexChart
            options={options}
            series={values}
            type="donut"
            height={CHART_HEIGHT}
            width="100%"
        />
    );
}

export default DashboardDonutChart;
